import type { Transition, Variants } from "motion/react";

export const loadingStateContainerVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0.95,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut" as const,
    },
  },
};

export const loadingStateTextVariants: Variants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut" as const,
      delay: 0.2,
    },
  },
};

export const loadingStateGradientAnimation = {
  initial: { backgroundPosition: "0% 50%" },
  animate: { backgroundPosition: "200% 50%" },
  transition: {
    duration: 8,
    repeat: Infinity,
    ease: "linear" as const,
  } satisfies Transition,
};

export const loadingStateIconAnimation = {
  animate: {
    rotate: [0, 5, -5, 0],
    scale: [1, 1.05, 1],
  },
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: "easeInOut" as const,
  } satisfies Transition,
};

export const loadingStateTitleAnimation = {
  animate: { opacity: [1, 0.7, 1] },
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: "easeInOut" as const,
  } satisfies Transition,
};

export const loadingStateDotAnimation = (index: number) => ({
  animate: {
    opacity: [0.3, 1, 0.3],
    scale: [1, 1.2, 1],
  },
  transition: {
    duration: 1.5,
    repeat: Infinity,
    ease: "easeInOut" as const,
    delay: index * 0.2,
  } satisfies Transition,
});
